<template>
  <div class="class-detail">
    <div class="container-fluid mt-1">
      <div class="row">
        <div class="col-xl-8 mb-5 mb-xl-0">
          <div v-if="classDetail.is_admin" class="box-article-form">
            <b-form class="article-form">
              <b-form-textarea id="article-input" class="article-input" name="article-input" v-model="article_form.status" placeholder="Apa yang ingin anda beritahukan?"></b-form-textarea>
              <b-form-group class="ml-1" label="Perlu upload file ?" label-for="published" label-cols-sm="3" label-align-sm="left">
                <b-form-radio-group id="article-publish" name="article_publish" v-model="article_form.is_file" :options="options" class="" value-field="item" text-field="name" disabled-field="notEnabled"></b-form-radio-group>
                <span :class="{ 'error-validation': errors.first('article-form.article_publish') }">{{ errors.first("article-form.article_publish") }}</span>
              </b-form-group>
              <b-form-group class="ml-1" v-if="article_form.is_file == 1" label="Input Link" label-for="Input Link" label-cols-sm="3" label-align-sm="left">
                <b-form-input v-model="article_form.file_path" v-validate="'required'"></b-form-input>
                <span :class="{ 'error-validation': errors.first('article-form.file_path') }">{{ errors.first("article-form.file_path") }}</span>
              </b-form-group>
              <div class="article-form-footer d-flex justify-content-end">
                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                <b-button v-if="!showLoader" variant="custom-primary" size="sm" style="width: 25%" @click="addAnnouncement">KIRIM</b-button>
              </div>
            </b-form>
          </div>
          <card header-classes="bg-transparent" body-classes="bg-transparent py-0" class="mt-4">
            <div v-if="classDetail.brc_on_class_list && classDetail.brc_on_class_list.length > 0">
              <div v-for="(item, index) in classDetail.brc_on_class_list" :key="index" class="card my-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <div class="left-content">
                    <div class="user-article">
                      <a href="javascript:void(0);" class="text-uppercase font-weight-bold">{{ item.full_name }}</a
                      >&nbsp; <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                      <a href="javascript:void(0);" class="text-uppercase font-weight-bold">{{ item.user_class }}</a>
                    </div>
                    <div class="role-article">
                      <small class="text-muted">{{ item.type }} - {{ item.created }}</small>
                    </div>
                  </div>
                  <div class="right-content" v-if="item.is_me">
                    <a href="javascript:void(0)" class="icon-clicked" @click="confirmDeleteStatus(item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                  </div>
                </div>
                <div class="card-body">
                  <p class="">{{ item.status }}</p>
                  <img v-if="item.is_file == 1 && item.file_path" class="img-center-200-x" width="100" :src="item.file_path" alt="Logo" />
                </div>
              </div>
            </div>
            <div v-else class="article p-4 text-center text-muted">Belum ada Postingan saat ini.</div>
          </card>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header row align-items-center bg-transparent">
              <div class="d-flex justify-content-between" style="align-items: center">
                <div class="col">
                  <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                </div>
                <div v-if="user.type == 'tutor' || user.type == 'admin'">
                  <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                    <b-dropdown-item @click="showClassSettingFormModal"><i class="fa fa-cog" aria-hidden="true"></i>Pengaturan Kelas</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="identity px-2">
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ classDetail.user_name }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ classDetail.user_status }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-bookmark" aria-hidden="true"></i>{{ classDetail.name }}</p>
              </div>
            </div>
            <div class="card-footer">
              <div class="card">
                <div class="card-body text-center">
                  <router-link :to="{ name: 'member-list', params: { classId: classDetail.id, taId: tahunAjaranId } }">
                    <h6>{{ classDetail.member }}</h6>
                    <h6>Anggota</h6>
                  </router-link>
                </div>
              </div>
              <div class="card">
                <div class="card-body text-center">
                  <h6>Ganjil: {{ classDetail.total_subjects1 }} Mata Pelajaran</h6>
                  <h6>Genap: {{ classDetail.total_subjects2 }} Mata Pelajaran</h6>
                </div>
              </div>
            </div>
          </div>
          <card header-classes="bg-transparent" class="mt-3">
            <div slot="header" class="row align-items-center">
              <div class="d-flex justify-content-between" style="align-items: center">
                <div>
                  <h6 class="text-uppercase ls-1 mb-1">Kode Kelas</h6>
                </div>
                <div v-if="user.type == 'tutor' || user.type == 'admin'">
                  <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                    <b-dropdown-item v-if="classDetail.is_lock == '0'" @click="lockOrUnlockClass(true)"><i class="fa fa-lock" aria-hidden="true"></i>Kunci Kelas</b-dropdown-item>
                    <b-dropdown-item v-if="classDetail.is_lock == '1'" @click="lockOrUnlockClass(false)"><i class="fa fa-unlock-alt" aria-hidden="true"></i>Buka Kunci</b-dropdown-item>
                    <b-dropdown-item @click="showClassSettingFormModal"><i class="fa fa-cog" aria-hidden="true"></i>Pengaturan Kelas</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="text-center">
              <h4 v-if="classDetail.is_lock == '0'">{{ classDetail.code }}</h4>
              <h4 v-if="classDetail.is_lock == '1'"><i class="fa fa-lock" aria-hidden="true"></i> TERKUNCI</h4>
            </div>
          </card>
          <card header-classes="bg-transparent" class="mt-3">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase ls-1 mb-1">Tentang Kelas</h6>
              </div>
            </div>
            <div class="text-center">
              <p>{{ classDetail.about }}</p>
            </div>
          </card>
          <card header-classes="bg-transparent" class="mt-3">
            <div slot="header" class="row align-items-center">
              <div class="d-flex justify-content-between" style="align-items: center">
                <div>
                  <h6 class="text-uppercase ls-1 mb-1">Daftar Mata Pelajaran</h6>
                </div>
                <div v-if="user.type == 'tutor' || user.type == 'admin'">
                  <base-dropdown :position="'right'" class="nav-link pr-0">
                    <div class="align-items-center" slot="title">
                      <b-button class="d-flex toggle-aksi align-items-center" size="sm">AKSI</b-button>
                    </div>
                    <template>
                      <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'">
                        <i class="fa fa-cogs" aria-hidden="true"></i>
                        <router-link :to="{ name: 'subject-list', params: { classId: classDetail.id } }" class="text-black">Kelola Mata Pelajaran</router-link>
                      </b-dropdown-item>
                      <a href="javascript:void(0)" to="#" class="dropdown-item" @click="showAddSubjectModal"><i class="fa fa-plus-circle"></i><span>Tambah Mata Pelajaran</span></a>
                    </template>
                  </base-dropdown>
                </div>
              </div>
            </div>
            <div class="subject-list">
              <div v-for="(item, index) in classDetail.subjects_list" :key="index">
                <div v-if="item.notVisible == '0'" class="col-lg-9 materi-name line-with-icon my-2" style="cursor: pointer" v-b-toggle="'collapse-modul-' + item.id">
                  <i class="clr-red fa fa-bookmark" aria-hidden="true"></i>
                  <div class="ml-1">
                    <b>
                      {{ item.name }}
                    </b>
                  </div>
                </div>
                <b-collapse v-if="item.notVisible == '0'" visible :id="'collapse-modul-' + item.id">
                  <b-card>
                    <div>
                      <p v-for="(item1, index1) in item.subjectList" :key="index1" class="line-with-icon">
                        <i class="clr-red fa fa-book" aria-hidden="true"></i>
                        <router-link :to="{ name: 'subject-detail', params: { subjectId: item1.id, taId: tahunAjaranId } }">{{ item1.name }}</router-link>
                      </p>
                    </div>
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <b-modal ref="new-subject-modal" class="new-subject-modal" size="md" title="Tambah Mata Pelajaran Baru" @show="resetAddSubjectForm" @hidden="resetAddSubjectForm" hide-footer no-close-on-backdrop>
      <add-subject-form :classId="classDetail.id"></add-subject-form>
    </b-modal>
    <b-modal ref="class-setting-form-modal" class="class-setting-form-modal" size="md" title="Pengaturan Kelas" @show="resetClassSettingForm" @hidden="resetClassSettingForm" hide-footer no-close-on-backdrop>
      <div class="class-setting-form">
        <div>
          <b-form data-vv-scope="class-setting-form">
            <b-form-group label="Nama Kelas" label-for="name" label-cols-sm="3" label-align-sm="left">
              <b-form-input id="input-nama-kelas" name="class_name" data-vv-as="Nama kelas" v-model="class_setting_form.name" type="text" placeholder="Nama Kelas Baru" v-validate="'required'" autocomplete="off"></b-form-input>
              <span :class="{ 'error-validation': errors.first('class-setting-form.class_name') }">{{ errors.first("class-setting-form.class_name") }}</span>
            </b-form-group>
            <b-form-group label="Tentang Kelas" label-for="about" label-cols-sm="3" label-align-sm="left">
              <b-form-textarea id="input-tentang-kelas" name="class_about" v-model="class_setting_form.about" placeholder="Tentang kelas..." rows="3" max-rows="6" no-resize></b-form-textarea>
              <span :class="{ 'error-validation': errors.first('class-setting-form.class_about') }">{{ errors.first("class-setting-form.class_about") }}</span>
            </b-form-group>
          </b-form>
        </div>
        <hr />
        <div class="new-class-footer d-flex justify-content-end">
          <square-loader :loading="showLoaderClassSetting" :color="'#ca062a'" :size="'30px'"></square-loader>
          <b-button v-if="!showLoaderClassSetting" variant="outline-danger" size="md" style="width: 25%" @click="hideClassSettingFormModal">BATAL</b-button>
          <b-button v-if="!showLoaderClassSetting" variant="primary" size="md" style="width: 25%" @click.prevent="saveClassSetting">SIMPAN</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
import AddSubjectForm from "../../../components/Main/AddSubjectForm";
export default {
  components: {
    SquareLoader,
    AddSubjectForm,
  },
  data() {
    return {
      showLoader: false,
      showLoaderClassSetting: false,
      article_form: {
        status: null,
        is_file: 0,
        file_path: "",
      },
      class_setting_form: {
        id: null,
        name: null,
        about: null,
      },
      tahunAjaranId: this.$route.params.taId,
      options: [
        { item: "1", name: "Ya" },
        { item: "0", name: "Tidak" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      classDetail: "getClassDetail",
    }),
  },
  watch: {
    classDetail(val) {
      this.class_setting_form.id = val.id;
      this.class_setting_form.name = val.name;
      this.class_setting_form.about = val.about;
    },
  },
  methods: {
    showAddSubjectModal() {
      this.$refs["new-subject-modal"].show();
    },
    hideAddSubjectModal() {
      this.$refs["new-subject-modal"].hide();
      this.resetAddSubjectForm();
    },
    resetAddSubjectForm() {
      EventBus.$emit("resetAddSubjectForm", true);
    },
    showClassSettingFormModal() {
      this.$refs["class-setting-form-modal"].show();
    },
    hideClassSettingFormModal() {
      this.$refs["class-setting-form-modal"].hide();
      this.resetClassSettingForm();
    },
    resetClassSettingForm() {
      this.class_setting_form.id = this.classDetail.id;
      this.class_setting_form.name = this.classDetail.name;
      this.class_setting_form.about = this.classDetail.about;
    },
    async saveClassSetting() {
      let scope = "class-setting-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoaderClassSetting = true;
          let form = this.class_setting_form;
          this.$store
            .dispatch("editClass", form)
            .then((res) => {
              this.showLoaderClassSetting = false;
              this.getClassDetail();
              this.hideClassSettingFormModal();
              this.$swal.fire("Success", res.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoaderClassSetting = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Failed", error.data.message, "error");
              }
            });
        }
      });
    },
    async getClassDetail() {
      let classId = this.$route.params.classId;
      let taId = this.$route.params.taId;
      await this.$store
        .dispatch("getClassDetail", { classId, taId })
        .then(() => {})
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    resetArticleForm() {
      this.article_form.status = null;
      this.article_form.is_file = 0;
      this.article_form.file_path = "";
    },
    async addAnnouncement() {
      if (this.article_form.status) {
        this.showLoader = true;
        let classId = this.$route.params.classId;
        let form = {
          class_id: classId,
          status: this.article_form.status,
          is_file: this.article_form.is_file,
          file_path: this.article_form.file_path,
        };
        await this.$store
          .dispatch("addAnnouncement", form)
          .then((res) => {
            this.showLoader = false;
            this.getClassDetail();
            this.resetArticleForm();
            this.$swal.fire("Success", res.message, "success");
          })
          .catch((err) => {
            this.showLoader = false;
            this.$swal.fire("Failed", err.response.data.message, "error");
          });
      } else {
        this.$swal.fire("Warning", "Pastikan pengumuman tidak kosong!", "warning");
      }
    },
    async lockClass() {
      let classId = this.$route.params.classId;
      let form = {
        class_id: classId,
      };
      await this.$store
        .dispatch("lockClass", form)
        .then((res) => {
          this.getClassDetail();
          this.resetArticleForm();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async lockOrUnlockClass(val) {
      let text = val ? "Saat Kelas di Kunci, maka tidak ada yang dapat bergabung ke dalam Kelas hingga anda membukanya kembali." : "Saat Kelas tidak di Kunci, maka murid dapat bergabung ke dalam Kelas hingga anda menguncinya kembali.";
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.lockClass();
          }
        });
    },
    async deleteStatus(id) {
      let form = {
        status_id: id,
      };
      await this.$store
        .dispatch("deleteStatus", form)
        .then((res) => {
          this.getClassDetail();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async confirmDeleteStatus(id) {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.deleteStatus(id);
          }
        });
    },
  },
  async created() {
    this.getClassDetail();
    EventBus.$on("hideAddSubjectModal", (val) => {
      if (val) {
        this.hideAddSubjectModal();
      }
    });
  },
};
</script>

<style lang="css" scoped>
.article-form {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #d8e2e7;
  margin: 0 0 20px;
}
.article-input:focus {
  border-color: transparent !important;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
.article-input {
  height: 60px;
  background: 0 0;
  border: none;
  -webkit-border-radius: 0;
  border-radius: 0;
  padding: 15px;
  color: #343434 !important;
  width: 100%;
  border-top: solid 1px #d8e2e7;
  min-height: 55px;
  overflow: hidden;
  resize: none;
}
.article-form-footer {
  background: #fbfcfd;
  padding: 12px 15px;
  border-top: solid 1px #d8e2e7;
}
.btn-custom-primary {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
}
.btn-custom-primary:hover,
.btn-custom-primary:not(:disabled):not(.disabled):active,
.btn-custom-primary:focus {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
.dropdown-menu .dropdown-item > i,
.dropdown-menu .dropdown-item > svg {
  vertical-align: -5%;
}
.user-article a {
  color: black;
}
.user-article a:hover {
  color: #ca062a;
}
.ml-1 {
  margin-left: 10px;
}
</style>
<style>
.toggle-aksi::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
</style>
